"use strict";

exports.__esModule = true;
exports.default = void 0;
var _Anchor = _interopRequireDefault(require("@restart/ui/Anchor"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = _Anchor.default;